import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import {
  MDBContainer,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBBtn,
  MDBIcon,
  MDBInput,
  MDBCheckbox
}
  from 'mdb-react-ui-kit';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom'; // Import useHistory for navigation
import { loginSuccess, logout } from '../slices/authSlice';
import { selectAuth } from '../slices/authSlice';
import { useSelector, useDispatch } from 'react-redux'


// Function to handle test button click
const handleTestButtonClick = async () => {
  try {
    const response = await axios.get('/api/test'); // Call the /test endpoint
    console.log('Test Response:', response.data); // Log the response data
  } catch (error) {
    console.error('Error calling /api/test:', error); // Log any errors
  }
};

const GreenTab = styled(MDBTabsLink)`
    background-color: green; /* Change to your desired shade of green */
    color: white; /* Change text color if needed */
`;

function LoginPage() {

  const [justifyActive, setJustifyActive] = useState('tab1');;
  const [districts, setDistricts] = useState([]);
  const [troupes, setTroupes] = useState([]);
  const [patrouilles, setPatrouilles] = useState([]);
  const [membres, setMembres] = useState([]);
  const [selectedDistrictId, setSelectedDistrictId] = useState(null);
  const [selectedTroupeId, setSelectedTroupeId] = useState(null);
  const [selectedPatrouilleId, setSelectedPatrouilleId] = useState(null);
  const [selectedMembreId, setSelectedMembreId] = useState(null);

  const [password, setPassword] = useState(''); // State for password
  const [errorMessage, setErrorMessage] = useState(''); // State for error message
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);

  const { isAuthenticated, userInformation } = useSelector(selectAuth);
  const dispatch = useDispatch()

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
    }

    setValidated(true);
    var api=''
    if(justifyActive === 'tab2'){
      api='/api/loginCT'
    }
    else if(justifyActive === 'tab1'){
      api='/api/login'
    }
    else{
      api='/api'
    }
    // Perform login
    try {
      const response = await axios.post(api, {
        username: selectedMembreId, // Use the selected member's ID
        password: password // Use the password entered
      });

      // If login is successful, save session status and redirect
      if (response.status === 200) {
        // Save session status if needed (e.g., using localStorage or context)
        // localStorage.setItem('session', JSON.stringify(response.data)); // Example
        console.log(response.data)
        dispatch(loginSuccess(response.data))
        navigate('/');  // Redirect to /home
      }
    } catch (error) {
      // Handle error and show message
      if (error.response) {
        setErrorMessage(error.response.data.message || 'Login failed. Please try again.');
      } else {
        setErrorMessage('An error occurred. Please try again.');
      }
    }
  };

  const fetchDistricts = async () => {
    try {
      const response = await axios.get('/api/districts');
      setDistricts(response.data);
      // console.log(response.data)
    } catch (error) {
      console.error('Error fetching districts:', error);
    }
  };

  const fetchTroupes = async () => {
    try {
      const response = await axios.get(selectedDistrictId ? `/api/troupes?districts=${selectedDistrictId}` : '/api/troupes');
      setTroupes(response.data);
    } catch (error) {
      console.error('Error fetching troupes:', error);
    }
  }

  const fetchPatrouilles = async () => {
    try {
      if (selectedTroupeId) {
        const response = await axios.get(`/api/patrouilles?troupes=${selectedTroupeId}`);
        setPatrouilles(response.data);
      }
      else {
        setPatrouilles([])
      }
    } catch (error) {
      console.error('Error fetching troupes:', error);
    }
  }

  const fetchCTs = async () => {
    try {
      const response = await axios.get(`/api/membres/idname?troupe=${selectedTroupeId}`);
      setMembres(response.data);
    } catch (error) {
      console.error('Error fetching troupes:', error);
    }
  }

  const fetchMembres = async () => {
    try {
      const response = await axios.get(`/api/membres/idname?patrouille=${selectedPatrouilleId}`);
      setMembres(response.data);
    } catch (error) {
      console.error('Error fetching troupes:', error);
    }
  }

  useEffect(() => {
    fetchDistricts();
  }, []);

  useEffect(() => {
    fetchTroupes();
  }, [selectedDistrictId]);

  useEffect(() => {
    fetchPatrouilles();
    fetchCTs();
  }, [selectedTroupeId]);

  useEffect(() => {
    fetchMembres();
  }, [selectedPatrouilleId]);

  const handleDistrictChange = (event) => {
    const districtId = event.target.value;
    setSelectedDistrictId(districtId);
    setSelectedTroupeId(null);
    setSelectedPatrouilleId(null);
    setSelectedMembreId(null);
    //empty lists
    setPatrouilles([])
    setMembres([])
  };

  const handleTroupesChange = (event) => {
    const id = event.target.value;

    setSelectedPatrouilleId(null);
    setSelectedMembreId(null);
    //empty lists
    setPatrouilles([])
    setMembres([])
    setSelectedTroupeId(id);
  };

  const handlePatrouillesChange = (event) => {
    const id = event.target.value;
    setSelectedPatrouilleId(id);
    setSelectedMembreId(null);
    //empty lists
    setMembres([])
  };

  const handleMembresChange = (event) => {
    const id = event.target.value;
    setSelectedMembreId(id);
    console.log(id);
  };


  const handleJustifyClick = (value) => {
    if (value === justifyActive) {
      return;
    }

    setJustifyActive(value);
  };

  return (
    <MDBContainer className="p-3 my-5 d-flex flex-column">

      <MDBTabs pills justify className='mb-3 d-flex flex-row justify-content-between'>
        <MDBTabsItem>
          <GreenTab onClick={() => handleJustifyClick('tab1')} active={justifyActive === 'tab1'} style={{
            backgroundColor: justifyActive === 'tab1' ? 'green' : 'transparent', // Green if active, transparent otherwise
            color: justifyActive === 'tab1' ? 'white' : 'black' // White text if active, black otherwise
          }}>
            Patrouille Login
          </GreenTab>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleJustifyClick('tab2')} active={justifyActive === 'tab2'} style={{
            backgroundColor: justifyActive === 'tab2' ? 'green' : 'transparent', // Green if active, transparent otherwise
            color: justifyActive === 'tab2' ? 'white' : 'black' // White text if active, black otherwise
          }}>
            CT/ACT Login
          </MDBTabsLink>
        </MDBTabsItem>
      </MDBTabs>

      <MDBTabsContent>

        <MDBTabsPane open={justifyActive === 'tab1'}>

          <Form noValidate validated={validated} onSubmit={handleSubmit}>

            <Form.Group controlId="validationCustom01">
              <Form.Label className="fw-bold">District</Form.Label>
              <Form.Select className="my-2" onChange={handleDistrictChange} defaultValue="" required>
                <option value="" ></option>
                {districts.map((district) => (
                  <option key={district.id} value={district.id}>
                    {district.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="validationCustom02">
              <Form.Label className="fw-bold">Troupes</Form.Label>
              <Form.Select className="my-2" onChange={handleTroupesChange} defaultValue="" required>
                <option value="" ></option>
                {troupes.map((troupe) => (
                  <option key={troupe.id} value={troupe.id}>
                    {troupe.groupe + (troupe.name ? " - " + troupe.name : "")}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="validationCustom03">
              <Form.Label className="fw-bold">Patrouilles</Form.Label>
              <Form.Select className="my-2" onChange={handlePatrouillesChange} defaultValue="" required>
                <option value="" ></option>
                {patrouilles.map((patrouille) => (
                  <option key={patrouille.id} value={patrouille.id}>
                    {patrouille.totem}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="validationCustom04">
              <Form.Label className="fw-bold">Membres</Form.Label>
              <Form.Select className="my-2" onChange={handleMembresChange} defaultValue="" required>
                <option value="" ></option>
                {membres.map((membre) => (
                  <option key={membre.id} value={membre.id}>
                    {membre.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="validationCustom05">
              <Form.Label className="fw-bold">Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Password"
                required onChange={(e) => setPassword(e.target.value)}
              />
              {errorMessage && <div className="text-danger">{errorMessage}</div>} {/* Display error message */}
            </Form.Group>
            {/* <Button variant="secondary" onClick={handleTestButtonClick} className="my-2">
              Test
            </Button> */}

            <div className="my-4 d-grid gap-2">
              <Button variant="success" type="submit">Sign in</Button>
            </div>
          </Form>

        </MDBTabsPane>

        <MDBTabsPane open={justifyActive === 'tab2'}>

          <Form noValidate validated={validated} onSubmit={handleSubmit}>

            <Form.Group controlId="validationCustom06">
              <Form.Label className="fw-bold">District</Form.Label>
              <Form.Select className="my-2" onChange={handleDistrictChange} defaultValue="" required>
                <option value="" ></option>
                {districts.map((district) => (
                  <option key={district.id} value={district.id}>
                    {district.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="validationCustom07">
              <Form.Label className="fw-bold">Troupes</Form.Label>
              <Form.Select className="my-2" onChange={handleTroupesChange} defaultValue="" required>
                <option value="" ></option>
                {troupes.map((troupe) => (
                  <option key={troupe.id} value={troupe.id}>
                    {troupe.groupe + (troupe.name ? " - " + troupe.name : "")}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="validationCustom08">
              <Form.Label className="fw-bold">Membres</Form.Label>
              <Form.Select className="my-2" onChange={handleMembresChange} defaultValue="" required>
                <option value="" ></option>
                {membres.map((membre) => (
                  <option key={membre.id} value={membre.id}>
                    {membre.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="validationCustom09">
              <Form.Label className="fw-bold">Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Password"
                required onChange={(e) => setPassword(e.target.value)}
              />
              {errorMessage && <div className="text-danger">{errorMessage}</div>} {/* Display error message */}
            </Form.Group>
            {/* <Button variant="secondary" onClick={handleTestButtonClick} className="my-2">
  Test
</Button> */}

            <div className="my-4 d-grid gap-2">
              <Button variant="success" type="submit">Sign in</Button>
            </div>
          </Form>

        </MDBTabsPane>


      </MDBTabsContent>
    </MDBContainer>
  );
}

export default LoginPage;